export default __webpack_public_path__ + "static/media/421.7561b6b1.png";